module.exports = __webpack_public_path__ + "img/activity@2x.c100a853.png";